import { Exception } from '../../../../errors/exception'
import { HttpStatusCode } from '../../../../errors/http-status-code'
import type { GetUserParams, GetUserResult } from '../../domain/models/get-user'
import type { IGetUser } from '../../domain/use-cases/i-get-user'
import type { IGetUserClient } from '../data-sources/i-get-user-client'

export class GetUserRepository implements IGetUser {
  constructor(private readonly dataSource: IGetUserClient) {}

  async get(params: GetUserParams): Promise<GetUserResult> {
    const result = await this.dataSource.get(params)

    if (result.status !== HttpStatusCode.OK) {
      throw new Exception(result.status, result?.message!)
    }

    return result.data
  }
}
